<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  //mixins: [mixins.reactiveProp],
  props: ["chartData", "options"],
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  created() {
    this.$bus.on("updateLine", this.updateChart);
  },
  methods: {
    updateChart() {
      this.renderChart(this.chartData, this.options);
    }
  }
};
</script>
